export default "__VITE_ASSET__89a279ec__"